'use strict';

var React = require('react'),
    ModalTypes = require('../constants/ModalTypes'),
    OverlayStore = require('../stores/OverlayStore'),
    ModalActionCreators = require('../actions/ModalActionCreators'),
    ZineStore = require('../stores/ZineStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    Terms = require('../modals/Terms'),
    ContactUs = require('../modals/ContactUs'),
    Settings = require('../modals/Settings'),
    ResetPassword = require('../modals/ResetPassword'),
    Login = require('../modals/Login'),
    Signup = require('../modals/Signup'),
    FinishSignup = require('../modals/FinishSignup'),
    UserStore = require('../stores/UserStore'),
    UserActionCreators = require('../actions/UserActionCreators'),
    AuthTypes = require('../constants/AuthTypes'),
    RequestResetPassword = require('../modals/RequestResetPassword'),
    SendInvite = require('../modals/SendInvite'),
    AboutForm = require('../modals/AboutForm'),
    Feedback = require('../modals/Feedback'),
    EditorHelp = require('../modals/EditorHelp'),
    Stamplet = require('../modals/Stamplet'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var ModalHost = React.createClass({
  mixins: [createStoreMixin(OverlayStore), PureRenderMixin],

  getStateFromStores() {
    var modal = OverlayStore.getModal();
    var state = {
      modal: modal,
      canHideModal: OverlayStore.canHideModal()
    };

    if (modal && modal.zineSlug) {
      state.zine = ZineStore.get(modal.zineSlug);
    }

    return state;
  },

  handleCloseClick() {
    ModalActionCreators.hideModal();
  },

  handleWrapperClick(e) {
    if (e.target === this.refs.wrapper.getDOMNode()) {
      ModalActionCreators.hideModal();
    }
  },

  render() {
    var { modal, canHideModal } = this.state;
    if (!modal) {
      return null;
    }

    return (
      <div className='Modal utils--hideScrollbars'>
        <div className='Modal-wrapper utils--hideScrollbars'
             ref='wrapper'
             onTouchTap={this.handleWrapperClick}>
          {this.getModal(modal, canHideModal)}
        </div>
      </div>
    );
  },

  getModal(modal, canHideModal) {
    switch (modal.id) {
    case ModalTypes.TERMS:
      return <Terms onCloseClick={this.handleCloseClick} />;

    case ModalTypes.CONTACT_US:
      return <ContactUs onCloseClick={this.handleCloseClick} />;

    case ModalTypes.SETTINGS:
      return <Settings onCloseClick={this.handleCloseClick}
                       initialTabId={modal.tab} />;

    case ModalTypes.RESET_PASSWORD:
      return <ResetPassword onCloseClick={this.handleCloseClick}
                            userId={modal.userId}
                            email={modal.email} />;

    case ModalTypes.LOGIN:
      return <Login onCloseClick={this.handleCloseClick}
                    onSignupClick={this.handleSignupClick}
                    onResetPasswordClick={this.handleResetPasswordClick}
                    allowClose={canHideModal}
                    email={modal.email}
                    password={modal.password}
                    endpoints={UserStore.getLoginEndpoints()}
                    messages={modal.messages || []} />;

    case ModalTypes.SIGNUP:
      return <Signup onCloseClick={this.handleCloseClick}
                     onLoginClick={this.handleLoginClick}
                     onServiceClick={this.handleSignupServiceClick}
                     allowClose={canHideModal}
                     endpoints={UserStore.getSignupEndpoints()}
                     messages={modal.messages || []}
                     showComplementaryButtons={modal.showComplementaryButtons} />;

    case ModalTypes.FINISH_SIGNUP:
      return <FinishSignup onCloseClick={this.handleCloseClick}
                           onLoginClick={this.handleLoginClick}
                           onTermsClick={this.handleTermsClick}
                           allowClose={canHideModal}
                           service={modal.service}
                           email={modal.email}
                           name={modal.name}
                           endpoints={UserStore.getSignupEndpoints()}
                           messages={modal.messages || []} />;

    case ModalTypes.REQUEST_RESET_PASSWORD:
      return <RequestResetPassword onCloseClick={this.handleCloseClick}
                                   onCancelClick={this.handleResetCancelClick}
                                   email={modal.email} />;

    case ModalTypes.SEND_INVITE:
      return <SendInvite onCloseClick={this.handleCloseClick}
                         zineSlug={modal.zineSlug}
                         title={modal.zineSlug ? 'Invite Contributors' : 'Invite Friends'}
                         setMayCloseOnClickOutside={this.handleMayCloseOnClickOutside} />;

    case ModalTypes.ABOUT:
      return <AboutForm onCloseClick={this.handleCloseClick}
                        onLoginClick={this.handleLoginClick} />;

    case ModalTypes.FEEDBACK:
      return <Feedback onCloseClick={this.handleCloseClick} />;

    case ModalTypes.EDITOR_HELP:
      return <EditorHelp onCloseClick={this.handleCloseClick} />;

    case ModalTypes.STAMPLET:
      return <Stamplet onCloseClick={this.handleCloseClick} />;
    }
  },

  handleResetCancelClick: function () {
    ModalActionCreators.showModal(ModalTypes.LOGIN);
  },

  handleResetPasswordClick: function () {
    ModalActionCreators.showModal(ModalTypes.REQUEST_RESET_PASSWORD);
  },

  handleLoginClick: function () {
    ModalActionCreators.showModal(ModalTypes.LOGIN);
  },

  handleSignupServiceClick: function (serviceType) {
    if (serviceType !== AuthTypes.EMAIL) {
      UserActionCreators.signupWithServiceAccount(serviceType);
    } else {
      ModalActionCreators.showModal(ModalTypes.FINISH_SIGNUP, { service: serviceType });
    }
  },

  handleSignupClick: function () {
    ModalActionCreators.showModal(ModalTypes.SIGNUP);
  },

  handleTermsClick: function () {
    var modal = this.state.modal;
    ModalActionCreators.showModal(ModalTypes.TERMS, { next: modal });
  }
});

module.exports = ModalHost;



/** WEBPACK FOOTER **
 ** ./hosts/ModalHost.jsx
 **/